import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import {
  GetSingleJenisPembiayaan,
  reset,
} from "../../../features/jenisPembiayaanSlice";
import {
  GetAllDokumenLoss,
  reset as resetDokumen,
} from "../../../features/DokumenSlice";
import {
  GetAllJenisPembiayaanDokumenByJenisPembiayaanID,
  reset as resetJenisPembiayaanDokumen,
} from "../../../features/jenisPembiayaanDokumenSlice";

import {
  Card,
  Button,
  Form,
  Col,
  Row,
  Table,
  ButtonGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";

import BASE_URL from "../../../api";

const FormJenisPembiayaanPage = () => {
  const [newData, setNewData] = useState({
    nama: "",
    active: true,
  });

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector(
    (state) => state.jenisPembiayaan
  );
  const {
    data: dataJenisPembiayaanDokumen,
    isLoading: isLoadingJenisPembiayaanDokumen,
  } = useSelector((state) => state.jenisPembiayaanDokumen);
  const { data: dataDokumen, isLoading: isLoadingMasterDokumen } = useSelector(
    (state) => state.dokumen
  );

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());
    dispatch(resetDokumen());
    dispatch(resetJenisPembiayaanDokumen());

    // fetch data.
    if (id) {
      fetchData();
    }
  }, [id, dispatch, token]);

  function fetchData() {
    dispatch(reset());
    dispatch(resetDokumen());
    dispatch(resetJenisPembiayaanDokumen());

    dispatch(GetAllDokumenLoss({ token }));
    dispatch(GetSingleJenisPembiayaan({ id, token }));
    dispatch(GetAllJenisPembiayaanDokumenByJenisPembiayaanID({ id, token }));
  }

  useEffect(() => {
    setNewData({
      nama: data?.data?.nama,
      active: data?.data?.active,
    });
  }, [data]);

  const onClickCheckMasterDokumen = (checked, idJenisPembiayaanDokumen) => {
    showAlertDialog({
      title: "Update?",
      msg: `apakah anda yakin ingin mengupdate data ini?`,
      confirmButtonText: "Update",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          response = await axios.put(
            `${BASE_URL}master/jenis_pembiayaan_dokumen/${idJenisPembiayaanDokumen}`,
            {
              is_mandatory: checked,
            },
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onClickAddMasterDokumen = (idDokumen) => {
    showAlertDialog({
      title: "Tambah?",
      msg: `apakah anda yakin ingin menambah data ini?`,
      confirmButtonText: "Tambah",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          response = await axios.post(
            `${BASE_URL}master/jenis_pembiayaan_dokumen`,
            {
              id_jenis_pembiayaan: id,
              id_dokumen: idDokumen,
              is_mandatory: true,
            },
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onClickDeleteMasterDokumen = (idJenisPembiayaanDokumen) => {
    showAlertDialog({
      title: "Hapus?",
      msg: `apakah anda yakin ingin menghapus data ini?`,
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          response = await axios.delete(
            `${BASE_URL}master/jenis_pembiayaan_dokumen/${idJenisPembiayaanDokumen}`,
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(
              `${BASE_URL}master/jenis_pembiayaan/${id}`,
              {
                ...newData,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}master/jenis_pembiayaan`,
              {
                ...newData,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate("/master/jenis-pembiayaan/list");
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/jenis-pembiayaan/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/jenis-pembiayaan/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/jenis-pembiayaan/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          newData={newData}
          setNewData={setNewData}
          isLoading={isLoading}
          isLocked={param.pathname.split("/")[3] === "view" || isLoading}
          isLoadingMasterDokumen={isLoadingMasterDokumen}
          dataDokumen={dataDokumen}
          isLoadingJenisPembiayaanDokumen={isLoadingJenisPembiayaanDokumen}
          dataJenisPembiayaanDokumen={dataJenisPembiayaanDokumen}
          onClickCheckMasterDokumen={onClickCheckMasterDokumen}
          onClickAddMasterDokumen={onClickAddMasterDokumen}
          onClickDelete={onClickDeleteMasterDokumen}
          handleSubmit={handleSubmit}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  isLoading = false,
  isLoadingMasterDokumen,
  dataDokumen,
  isLoadingJenisPembiayaanDokumen,
  dataJenisPembiayaanDokumen,
  handleSubmit,
  onClickAddMasterDokumen,
  onClickCheckMasterDokumen,
  onClickDelete,
}) => {
  // edit dokumen list, remove the data if it is already have it
  const editedDataDokumen = () => {
    return dataDokumen?.data?.filter((el) => {
      return !dataJenisPembiayaanDokumen?.data
        ?.map((item) => item.id_dokumen)
        ?.includes(el.id);
    });
  };

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group id="Nama">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama"
                  disabled={isLocked}
                  value={newData.nama || ""}
                  onChange={(e) =>
                    setNewData({ ...newData, nama: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          {/* List Master Dokumen */}
          {id && isLocked ? (
            <>
              <hr data-content="Master Dokumen" className="hr-text" />
              <Row>
                <Col xl={7} md={12} className="mb-3">
                  <Table
                    responsive
                    striped
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0">#</th>
                        <th className="border-0">Nama Dokumen</th>
                        <th className="border-0">Mandatory?</th>
                        <th className="border-0">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingJenisPembiayaanDokumen ? (
                        <tr>
                          <th colSpan="7" style={{ textAlign: "center" }}>
                            Loading...
                          </th>
                        </tr>
                      ) : (dataJenisPembiayaanDokumen?.data || []).length >
                        0 ? (
                        dataJenisPembiayaanDokumen?.data?.map((item, i) => (
                          <tr key={i}>
                            <th>{i + 1}</th>
                            <th>{item.nama_dokumen}</th>
                            <th style={{ textAlign: "center" }}>
                              <Form.Check
                                type="checkbox"
                                checked={item.is_mandatory}
                                onChange={(evt) =>
                                  onClickCheckMasterDokumen(
                                    evt.target.checked,
                                    item.id
                                  )
                                }
                              />
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ButtonGroup size="sm">
                                <Button
                                  variant="danger"
                                  onClick={() => onClickDelete(item.id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              </ButtonGroup>
                            </th>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <th colSpan="7" style={{ textAlign: "center" }}>
                            Tidak ada data!
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
                <Col xl={5} md={12} className="mb-3">
                  <Table
                    responsive
                    striped
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0">#</th>
                        <th className="border-0">Nama Dokumen</th>
                        <th className="border-0">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingMasterDokumen ? (
                        <tr>
                          <th colSpan="7" style={{ textAlign: "center" }}>
                            Loading...
                          </th>
                        </tr>
                      ) : (editedDataDokumen() || []).length > 0 ? (
                        editedDataDokumen()?.map((item, i) => (
                          <tr key={i}>
                            <th>{i + 1}</th>
                            <th>{item.nama}</th>
                            <th style={{ textAlign: "center" }}>
                              <ButtonGroup size="sm">
                                <Button
                                  onClick={() =>
                                    onClickAddMasterDokumen(item.id)
                                  }
                                >
                                  <FontAwesomeIcon icon={faPlus} />
                                </Button>
                              </ButtonGroup>
                            </th>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <th colSpan="7" style={{ textAlign: "center" }}>
                            Tidak ada data!
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </>
          ) : null}
          <div>
            {!isLocked ? (
              <Button type="submit">{id ? "Update" : "Simpan"}</Button>
            ) : null}
          </div>
        </Form>
      )}
    </Card.Body>
  );
};

export default FormJenisPembiayaanPage;
